import React, {useCallback, useEffect, useState} from "react";
import "./index.css";
import HeaderLogo from "../LoginScreen/HeaderLogo";
import Star from "../../Icons/Star";
import BrandButton from "../BrandButton";
import Modal from "react-modal";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import useRazorpay from "react-razorpay";
import Success from "../../Icons/Success";
import {ToastContainer, toast} from "react-toastify";
import Steps from "../PersonalInfoForm/Steps";
import Completed from "../../Icons/Completed";
import ETAFile from "./ETA";
import axios from "axios";
import OverlayLoader from "../../spinner";
import { Helmet } from "react-helmet";
import HeaderWithMenu from "../../Common/HeaderWithMenu.tsx";
import {WebRoutes} from "../../../Routes/WebRoutes";
import PrimaryButton from "../../Common/PrimaryButton.tsx";
import {STATUS_STYLES} from "../../../Constants/Colors";
import {UpcomingAppointmentInformation} from "../../Appointment/UpcomingAppointmentInformation.tsx";



function getCurrentTimeFormatted() {
    const now = new Date();

    // India Standard Time (IST) is UTC+05:30
    const IST_OFFSET = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
    const istNow = new Date(now.getTime() + IST_OFFSET);

    const pad = (num, size = 2) => String(num).padStart(size, '0');

    const year = istNow.getUTCFullYear();
    const month = pad(istNow.getUTCMonth() + 1);
    const date = pad(istNow.getUTCDate());
    const hours = pad(istNow.getUTCHours());
    const minutes = pad(istNow.getUTCMinutes());
    const seconds = pad(istNow.getUTCSeconds());
    const milliseconds = pad(istNow.getUTCMilliseconds(), 3);

    return `${year}-${month}-${date}T${hours}:${minutes}:${seconds}.000+05:30`;
}

export default function BookingPage() {
  const [isPaymentDone, setIsPaymentDone] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [APILoader, setAPILoader] = useState(false);
  const [amount, setAmount] = useState("1499");

    const [doctorModal, setDoctorModal] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const [searchParams, setSearchParams] = useSearchParams();

    let bookedSlot = searchParams.get("bookedSlot");
    let urlAppId = searchParams.get("appId") || "";
    const payment = searchParams.get("payment");
    const [instructionsStatus, setInstructionsStatus] = useState(
        sessionStorage.getItem(urlAppId) || "idle"
    );

  const isPlumPage = !!window.location.href.includes("plum");
  const [isLoading, setIsLoading] = useState(false);
  const TOTAL_TIMER_DURATION = 90;
  // Display timer duration is 90 seconds (1:30)
  const DISPLAY_TIMER_DURATION = 90;
  const savedAppointment = localStorage.getItem("savedAppointment");
  const [appointment, setAppointment] = useState(() => {
    // const savedAppointment = localStorage.getItem("savedAppointment");
    return savedAppointment ? JSON.parse(savedAppointment) : null
  });
  let timeInSec
  if (appointment) {
    const { created_at } = JSON.parse(savedAppointment)
    const appointmentStartTime = new Date(created_at);
    const currentTime = new Date();

    // Calculate the difference in milliseconds
    let diffMs = currentTime - appointmentStartTime;
    let diffMinutes = diffMs / (1000 * 60);
    timeInSec = (diffMinutes) * 60
  }
  const [payTimer, setPayTimer] = useState(90-timeInSec > 90 ? 90 : 90-Math.floor(timeInSec));
  const [timerStage, setTimerStage] = useState(1);
  const [appId, setAppId] = useState(urlAppId);
  const [heavyModal, setHeavyModal] = useState(false);
  const [progress, setProgress] = useState(0);
  const [modalIsOpen, setIsOpen] = useState(90 < timeInSec);
  const [crds, setCrds] = useState({ lat: "", lng: "" });
  const onReset = () => {
    window.location.href = isPlumPage ? "/" : "/";
  };

    const [ETA, setETA] = useState(0);
    // const [appointment, setAppointment] = useState({});

  // const [doctorDetails, setDoctorDetails] = useState(null);
  

    const [doctorDetails, setDoctorDetails] = useState(() => {
        const savedDoctorDetails = localStorage.getItem("savedDoctorDetails");
        return savedDoctorDetails ? JSON.parse(savedDoctorDetails) : null;
    });
    // const [currentOrderId, setCurrentOrderId] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState("idle"); // Added state for payment status

    const handleInstructions = async () => {
        // Get the value from textarea
        const instructionsText = document.querySelector("textarea").value.trim();

        // Check if instructions are empty
        if (!instructionsText) {
            alert("Please enter instructions for the doctor");
            return;
        }

        setIsLoading(true);

        try {
            const token = localStorage.getItem("token");

            // Create headers
            const myHeaders = new Headers();
            myHeaders.append("token", token);
            myHeaders.append("Content-Type", "application/json");

            const requestBody = {
                id: appointment.id,
                appointment: {
                    customer_instructions: instructionsText,
                },
            };

            const response = await fetch(
                `${process.env.REACT_APP_KMS_BASE_URL}/api/customers/appointments/add_instructions_for_doctor`,
                {
                    method: "PUT",
                    headers: myHeaders,
                    body: JSON.stringify(requestBody),
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            toast.success("Instructions sent");
            setInstructionsStatus("success");
            const data = await response.json();

            sessionStorage.setItem(urlAppId, "success");

            document.querySelector("textarea").value = "";
        } catch (error) {
            console.error("Error sending instructions:", error);
            toast.error(error || "Error sending instructions.");
        } finally {
            setIsLoading(false);
        }
    };

  useEffect(() => {
    if (appointment && Object.keys(appointment).length > 0) {
      // localStorage.setItem("savedAppointment", JSON.stringify({...appointment}));
    }
  }, [appointment]);

    useEffect(() => {
        if (doctorDetails) {
            localStorage.setItem("savedDoctorDetails", JSON.stringify(doctorDetails));
        }
    }, [doctorDetails]);

    useEffect(() => {
        if (appointment) {
            let ETA = 0;

            if (appointment.appointment_start_time) {
                const currentTime = new Date();
                const appointmentStartTime = new Date(
                    appointment.appointment_start_time
                );

                const diff = appointmentStartTime - currentTime + 180 * 1000;
                ETA = Math.floor(diff / 60000);
            }

      const adjustedETA = ETA < 5 ? 5 : ETA; // Ensuring a minimum ETA of 5 minutes
      setETA(calculateETA());
      setDoctorDetails(appointment?.doctor);

      // Check if ETA is greater than 90 and update heavyModal
      if (adjustedETA > 90) {
        // setHeavyModal(true);
      }
    }
  }, [appointment]);

    useEffect(() => {
        let payT;
        if (!appId) {
            return;
        }

    if (appointment && Object.keys(appointment).length > 0) {
      payT = setInterval(() => {
        setPayTimer((prev) => {
          // let payTime  = 
          if (payTimer <= 0) {
            clearInterval(payT);
          }

            if (!isPaymentDone) {
              const { created_at } = JSON.parse(localStorage.getItem("savedAppointment"))
              const appointmentStartTime = new Date(created_at);
              const currentTime = new Date();

              // Calculate the difference in milliseconds
              let diffMs = currentTime - appointmentStartTime;
              let diffMinutes = diffMs / (1000 * 60);
              let timeInSec = (diffMinutes) * 60
              if (timerStage === 1 && (90-timeInSec) > 0) {
                // setTimerStage(2);
                // Reset timer for second stage, but keep total duration
                // let payTime  = payTimer - 1
                // setPayTimer(payTime);
              } else {
                setIsOpen(true);
              }
            }
          //   return 0;
          // }
          return prev - 1;
        });
      }, 1000);
    }

        return () => {
            payT && clearInterval(payT);
        };
    }, [appointment, appId, isPaymentDone, timerStage]);

    const displayTimer = Math.min(payTimer, DISPLAY_TIMER_DURATION);

    const handleFetchAppointmentDetails = async () => {
        const myHeaders = new Headers();
        myHeaders.append("token", localStorage.getItem("token"));
        myHeaders.append("user_id", localStorage.getItem("user_id"));

    setIsLoading(true);
    setAPILoader(true);

        try {
            let appointmentDetails = await fetch(
                process.env.REACT_APP_KMS_BASE_URL +
                `/api/customers/appointments/${appId}`,
                {
                    headers: myHeaders,
                }
            );

            appointmentDetails = await appointmentDetails.text();
            appointmentDetails = JSON.parse(appointmentDetails);

            setAppointment(appointmentDetails);

            // Check if current time is between 7 AM and 7 PM
            const currentTime = new Date();
            const currentHour = currentTime.getHours();

            if (currentHour >= 7 && currentHour < 19) {
                setAmount(999);
            }

      if (appointmentDetails && appointmentDetails.appointment_start_time) {
        let ETA = 0;
        if (appointmentDetails.appointment_start_time) {
          const appointmentStartTime = new Date(
            appointmentDetails.appointment_start_time
          );
          const diff = appointmentStartTime - currentTime;
          ETA = Math.floor(diff / 60000);
          if (appointmentDetails?.status === "upcoming" || appointmentDetails?.status === "ongoing") {
              setSearchParams({ appId: urlAppId, payment: "success" });
          } else {
            setSearchParams({ appId: urlAppId });
            // window.location.href = window.location.href
            // window.location.reload()
          }
        }
        let calETA = calculateETA()
        setETA(calETA < 5 ? 5 : calETA);
      } else {
        setAppId(null);
        navigate("/book-doctor/step-1");
      }
    } catch (error) {
      setAppId(null);
      navigate("/book-doctor/step-1");
    } finally {
      setIsLoading(false);
      setAPILoader(false);
    }
  };

  useEffect(() => {
    if (!appId) {
      return;
    }
    // setPayTimer(timeInSec)
    handleFetchAppointmentDetails();
  }, [appId]);

    useEffect(() => {
        if (instructionsStatus === "success") return;

        const intersector = new IntersectionObserver((entries) => {
            const button1 = document.getElementById("inter-btn");
            if (!button1) return;
            if (entries?.[0].isIntersecting) {
                button1.style.visibility = "hidden";
            }
            if (!entries?.[0].isIntersecting) {
                button1.style.visibility = "visible";
            }
        });

        const intructionele = document.getElementById("instruction-bar");

        if (intructionele) {
            intersector.observe(intructionele);
        }

        return () => {
            if (intersector) {
                intersector.disconnect();
            }
        };
    }, [instructionsStatus]);

    useEffect(() => {
        if (!appId) return;
        if (!payment) return;
        if (ETA <= 0) return;

    // const timer = setInterval(() => {
    //   console.log({ETA})
    //   // setETA((prevTime) => prevTime - 1);
    //   if (ETA > 90) {
    //     // setHeavyModal(true);
    //   }
    // }, 60000); // Subtract 1 every 60,000 ms (1 minute)

    // return () => clearInterval(timer); // Cleanup on unmount
  }, [ETA]);

    useEffect(() => {
        if (bookedSlot) {
            localStorage.setItem("bookedSlot", bookedSlot);
        }
    }, [bookedSlot]);

    const [Razorpay, isLoaded] = useRazorpay();

    const updateAppointmentWithHealthConcerns = async (appointmentId) => {
        const healthConcernsValue = localStorage.getItem("healthConcerns") || "";

        const myHeaders = new Headers();
        myHeaders.append("token", localStorage.getItem("token"));

        const formData = new FormData();
        formData.append("appointment_complains_attributes[0][complain_id]", "95"); // Using 95 as the complain_id from your example
        formData.append(
            "appointment_complains_attributes[0][description]",
            healthConcernsValue
        );

        const requestOptions = {
            method: "PUT",
            headers: myHeaders,
            body: formData,
            redirect: "follow",
        };

        try {
            const response = await fetch(
                `${process.env.REACT_APP_KMS_BASE_URL}/api/customers/appointments/${appointmentId}`,
                requestOptions
            );

            const result = await response.json();

            console.log("Health concerns updated for appointment:", result);
            return result;
        } catch (error) {
            console.error("Error updating appointment with health concerns:", error);
            return null;
        }
    };

  const getLocation = () => {
    // setIsAddressChanged(false);
    // setIsMapOpen(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        fetchLocationFromLatLong
        // showError
      );
    } else {
      // setErrorMessage("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    let userId = localStorage.getItem("user_id") || sessionStorage.getItem("user_id")
    if (!token || !userId) {
      localStorage.clear()
      navigate("/book-doctor/step-1");
    } else {
      let savedAppointment = localStorage.getItem("savedAppointment")
      if (!savedAppointment || !urlAppId) {
        // savedAppointment = JSON.parse(savedAppointment)
        navigate(`/book-doctor/step-2`)
      }
    }
  },[urlAppId, navigate]);

    const fetchLocationFromLatLong = async (position) => {
        // setIsAddressChanged(false);
        const {latitude, longitude} = position.coords;
        // setLatLong(`${latitude}, ${longitude}`);
        setCrds({lat: latitude, lng: longitude});
        // const apiKey = process.env.NEXT_PUBLIC_MAP_KEY;
        // const url = fetch(`/ssr-api/location?latitude=${latitude}&longitude=${longitude}`);

        try {
            const response = await fetch(
                `https://kynohealth.com/ssr-api/location?latitude=${latitude}&longitude=${longitude}`
            );
            const data = await response.json();
            if (data.results && data.results.length > 0) {
                const userLocation = data.results[0].formatted_address;

                // try {
                //   const list = data?.results[0].address_components.find((e) =>
                //     e.types.includes("postal_code")
                //   );

                //   if (list) {
                //     setPostalCode(list.long_name);
                //   }

                //   const city = data?.results[0].address_components.find((e) =>
                //     e.types.includes("locality")
                //   );
                //   if (city) {
                //     setCity(city.long_name);
                //   }
                // } catch (error) {}

                // setArea(userLocation);
                // setQuery(userLocation);
                // // setSelectedLocation(userLocation);
                // toggleAddressLabel(true);
                // //   setLocationInput(userLocation)
                // setShowDropdown(false);
            } else {
                // setErrorMessage("Unable to fetch location details.");
                toast.error("unable to find doctor at your location");
            }
        } catch (err) {
            toast.error("unable to find doctor at your location");
        }
    };

    const createAppointment = async () => {
        const formData = new FormData();
        const myHeaders = new Headers();
        myHeaders.append("token", localStorage.getItem("token"));
        formData.append("patient_id", localStorage.getItem("user_id"));
        formData.append("latitude", crds?.lat || "");
        formData.append("longitude", crds.lng || "");
        formData.append("source", "website");

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formData,
            redirect: "follow",
        };

        try {
            const response = await fetch(
                process.env.REACT_APP_KMS_BASE_URL + "/api/customers/express_book",
                requestOptions
            );

            const result = await response.text();
            const res = JSON.parse(result);

            console.log("express", {result}, res);

      if (!res.appointment_id) {
        setAppointment(null);
        localStorage.removeItem("savedAppointment")
        // localStorage.setItem("savedAppointment", {
        //   ...JSON.parse(localStorage.getItem("savedAppointment")),
        //   appointment_start_time: null,
        //   created_at: null
        // })
        setHeavyModal(true);
        toast.error(
          res?.errors ||
            "Appointment can't be booked now, please contact support."
        );
        return;
      }
      setIsOpen(false);
      setPayTimer(90);

            // Update the appointment with health concerns
            await updateAppointmentWithHealthConcerns(res.appointment_id);

            // Continue with the rest of the function
            let appointmentDetails = await fetch(
                process.env.REACT_APP_KMS_BASE_URL +
                `/api/customers/appointments/${res.appointment_id}`,
                {
                    headers: myHeaders,
                }
            );

            appointmentDetails = await appointmentDetails.text();
            appointmentDetails = JSON.parse(appointmentDetails);

      if (appointmentDetails.appointment_start_time) {
        setAppointment(appointmentDetails);
        localStorage.setItem("savedAppointment", JSON.stringify({
          ...appointmentDetails,
          // appointment_start_time: null,
          // created_at: getCurrentTimeFormatted()
        }))
        // navigate(`/book-doctor/step-3?appId=${res.appointment_id}`);
        window.location.href = `/book-doctor/step-3?appId=${res.appointment_id}`;
      } else {
        setAppointment(null);
      }

      if (res.razorpay_order_id && res.appointment_id) {
        toast.success("Appointment Booked!");
        setAPILoader(false);
      } else {
        // toast.error(
        //   res?.errors ||
        //     "Appointment can't be booked now, please contact support."
        // );
      }
    } catch (error) {
      // setAPILoader(false);
      setHeavyModal(true);
      localStorage.setItem("savedAppointment", {
        ...JSON.parse(localStorage.getItem("savedAppointment")),
        appointment_start_time: null,
        created_at: null
      })
      toast.error(
        error?.errors ||
          "Appointment can't be booked now, please contact support."
      );
      console.log("error", error);
    }
  };

    const handleNavigationAdrress = async () => {
        getLocation();
        setAPILoader(true);
        await createAppointment();
        navigate("");
    };
    const attemptPayment = async (appointmentId) => {
        const myHeaders = new Headers();
        myHeaders.append("token", localStorage.getItem("token"));

        const requestOptions = {
            method: "PUT",
            headers: myHeaders,
            redirect: "follow",
        };

        try {
            const response = await fetch(
                `${process.env.REACT_APP_KMS_BASE_URL}/api/customers/payments/attempt_for_payment?appointment_id=${appointmentId}`,
                requestOptions
            );

            const result = await response.text();
            const res = JSON.parse(result);

            console.log("Payment Attempt", {result}, res);

            return res;
        } catch (error) {
            console.error("Payment attempt failed:", error);
            throw error;
        }
    };
    const handlePayment = async () => {
        try {
            window.dataLayer.push({event: "initiate_checkout"});

            // Attempt payment first
            attemptPayment(appointment.id);

            setPaymentStatus("pending");
            const options = {
                order_id: appointment.razorpay_appointment_id,
                currency: "INR",
                name: "Kyno Health",
                timeout: 90,
                image: "https://www.kynohealth.com/images/Kyno-footer-logo.png",
                handler: (res) => {
                    if (res.razorpay_payment_id) {
                        setPaymentStatus("pending");
                        setIsPaymentDone(true);
                        setShowSuccess(true);
                        setIsOpen(false);

                        setTimeout(() => {
                            setSearchParams({appId: urlAppId, payment: "success"});
                            setShowSuccess(false);
                        }, 2000);

                        // navigate("/booking-confirmed");
                    } else {
                        setPaymentStatus("failure");
                        setIsOpen(true);
                    }
                    console.log(res);
                },
                modal: {
                    ondismiss: function () {
                        console.log("hello closing");
                        setPaymentStatus("failure");
                    },
                },
                prefill: {
                    contact: localStorage.getItem("phone"),
                },
                notes: {
                    appointment_id: appointment?.id,
                    transaction_type: "pre_payment",
                    payment_mode: "online",
                    payment_for: "appointment_advance_payment",
                    address:
                        "HUAMI TECHNOLOGIES PRIVATE LIMITED, H NO M 37, THIRD FLOOR, MAYFIELD GARDEN, SECTOR 52, OPPOSITE ARTEMIS HOSPITAL, GURGAON, Gurgaon, Haryana, India, 122001",
                },
                theme: {
                    color: "#003C3C",
                },
            };

            const rzpay = new Razorpay(options);
            rzpay.open();
        } catch (error) {
            console.error(
                "Payment attempt or Razorpay initialization failed:",
                error
            );
            setPaymentStatus("failure");
        }
    };

    const subtotal =
        new Date().getHours() >= 7 && new Date().getHours() < 19 ? 999 : 1499;


  // Calculate progress and ETA
  const getProgress = useCallback(() => {
    if (appointment?.appointment_start_time && appointment?.travel_time) {
      const startTime = new Date(appointment.appointment_start_time);
      const createdAt = new Date(appointment.created_at)
      const currentTime = new Date();
      const totalDuration = (startTime - createdAt)/60000
      //  appointment.travel_time; // Total travel time in minutes
  
      const elapsedTime = (startTime - currentTime) / 60000; // Convert ms to minutes
  
      // Ensure progress stays between 0% and 100%
      const progress = Math.max(0, Math.min((1- (elapsedTime / totalDuration)) * 100, 100));
      // console.log({startTime, currentTime, totalDuration, progress, elapsedTime})
  
      return progress;
    }
    return 0;
  }, [appointment]);

  const calculateETA = useCallback(() => {
    if (appointment && appointment?.appointment_start_time) {
      const timbar = new Date();
      const totaltime =
        (new Date(appointment.appointment_start_time) - timbar) / 60000;
      const T = (new Date() - timbar) / 60000;
      return Math.max(totaltime - T, 5); // Ensure ETA doesn't go negative
    }
    return 0;
  }, [appointment]);

  // Update progress and ETA every 5 seconds
   // Update progress and ETA every 5 seconds
   useEffect(() => {
    setProgress(getProgress());
    setETA(calculateETA());
    const interval = setInterval(() => {
      setProgress(getProgress());
      setETA(calculateETA());
    }, 5000);

    return () => clearInterval(interval);
  }, [getProgress, calculateETA]);

  console.log("Progress:", progress);

  const doctorDetailsJsx = () => {
    return (
      <>
        <Helmet>
          <style>{`body { font-family: 'Poppins', sans-serif; }`}</style>
        </Helmet>
        {" "}
        <OverlayLoader loading={APILoader} color="#169d82"></OverlayLoader>
        <div className="doctor-profile-container">
          <img
            src={`${doctorDetails?.avatar_url}`}
            alt="doctor"
            style={{
              background: "#ddd",
              height: "140px",
              width: "140px",
              borderRadius: "12px",
              objectFit: "cover",
              marginLeft: "18px",
            }}
          />
          <div className="doctor-details">
            <p className="doctor-name">Dr. {doctorDetails?.user_full_name}</p>
            <p className="doctor-role">
              {doctorDetails?.doctor_detail?.specialization} (
              {doctorDetails?.doctor_detail?.qualifications})
            </p>
          </div>
        </div>
        <div className="doctor-rating-overview">
          <div>
            <p>{doctorDetails?.doctor_detail?.kyno_visits_count}+</p>
            <p className="subtext">KYNO Visits</p>
          </div>{" "}
          <div>
            <p>
              {" "}
              <Star /> {doctorDetails?.doctor_detail?.rating}
              {/* <span>({doctorDetails?.doctor_detail?.reviews_count})</span> */}
            </p>
            <p className="subtext">Google Reviews</p>
          </div>
        </div>
        <div
          class="doctor-screen-container-inner-medical"
          style={{
            marginTop: "16px",
            textAlign: "center",
            color: "#555",
            fontSize: "14px",
            padding: "10px",
            border: "1px solid #999",
          }}
        >
          <div>
            <img
              src={doctorDetails?.doctor_detail?.medical_logo}
              alt="Medical Registration"
            />
          </div>
          <div>
            <p style={{ margin: "0px", fontWeight: "500" }}>
              Medical Registration
            </p>
            <p style={{ fontWeight: "bold", margin: "0px" }}>
              {doctorDetails?.doctor_detail?.registration_number}
            </p>{" "}
          </div>
        </div>
        <div className="experience-container">
          <h3>Previous Experience</h3>
          <p>{doctorDetails?.doctor_detail?.experience}</p>
        </div>
      </>
    );
  };

  const prePaymentLayoutJsx = () => {
    return (
      <>
        <Helmet>
          <style>{`body { font-family: 'Poppins', sans-serif; }`}</style>
        </Helmet>
        {" "}
        <OverlayLoader loading={APILoader} color="#169d82"></OverlayLoader>
        <div style={{
              padding: "10px 16px 0",
              width: "100%",
              gap: "12px"
        }}>
          <img
            src="/images/Every_Kyno_Doctor.jpg"
            alt="doctor"
            style={{
              background: "#ddd",
              width: "100%",
              borderRadius: "12px",
              objectFit: "cover",
              boxShadow: "0 1px 1px rgba(0, 0, 0, 0.15), 0 2px 2px rgba(0, 0, 0, 0.15), 0 4px 4px rgba(0, 0, 0, 0.15), 0 8px 8px rgba(0, 0, 0, 0.15)"
            }}
          />
          <div style={{
            padding: "20px 0",
            fontSize: "13px",
            fontWeight: "bold",
            fontStyle: "italic"
          }}>You will recieve details of the visiting doctor once appointment is confirmed.</div>
          </div>
      </>
    );
  };


    return (
        <div
            className="booking-container"
            style={{
                position: "relative",
                ...(doctorModal && {overflow: "hidden"}),
            }}
        >
            {doctorModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        display: "flex",
                        alignItems: "center",
                        zIndex: "999",
                        justifyContent: "center",
                        backdropFilter: "blur(3px) brightness(0.5)",
                        height: "100%",
                        maxWidth: "500px",
                    }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDoctorModal(false);
                    }}
                >
                    <div
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                        style={{
                            width: "90%",
                            background: "#fff",
                            // padding: "22px",
                            borderRadius: "12px",
                        }}
                    >
                        {" "}
                        {doctorDetailsJsx()}
                    </div>
                </div>
            )}
            <ToastContainer></ToastContainer>
            {payment === "success" ?
                <HeaderWithMenu/>
                : <HeaderLogo/>}
            {!payment || payment === "pending" ? <Steps currentStep={4}/> : ""}
            {payment === "success" ? (
                <>
                    <h2 style={{textAlign: "center"}}>
                        Appointment ID: {appointment?.id}
                    </h2>
                    {/* <div style={{ width: "100%" }}>
            <div className="arrive-element">
              Doctor is available to reach in{" "}
              {90 > ETA && ETA >= 60
                ? appointment?.appointment_start_time
                  ? new Date(
                      appointment?.appointment_start_time
                    ).toLocaleString("en-IN", {
                      timeStyle: "short",
                    })
                  : `${ETA} Minutes`
                : `${ETA} Minutes`}{" "}
            </div>
            {60 > ETA && ETA >= 30 && (
              <p
                style={{
                  fontSize: "12px",
                  color: "#161616",
                  padding: "12px 16px",
                  margin: "0",
                }}
              >
                {" "}
                Doctor is {ETA} minutes away from you & completing a
                consultation nearby.
              </p>
            )}

            {90 > ETA && ETA >= 60 && (
              <p
                style={{
                  fontSize: "12px",
                  color: "#161616",
                  padding: "12px 16px",
                  margin: "0",
                }}
              >
                {" "}
                We are facing high demand at the moment.
              </p>
            )}
          </div> */}
          <div
            style={{ width: "100%", marginTop: "12px", paddingInline: "16px" }}
          >
            <h3 style={{ textAlign: "start" }}>Doctor Details</h3>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                background: "#f9f9f9",
                padding: "20px",
                borderRadius: "12px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "16px",
                  alignItems: "self-start",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flex: "1",
                  }}
                >
                  <img
                    src={`${doctorDetails?.avatar_url}`}
                    alt="doctor"
                    style={{
                      background: "#ddd",
                      height: "60px",
                      width: "60px",
                      borderRadius: "12px",
                      objectFit: "cover",
                    }}
                  />
                  <div className="doctor-details">
                    <p className="doctor-name">
                      Dr. {doctorDetails?.user_full_name}
                    </p>
                    <p className="doctor-role">
                      {doctorDetails?.doctor_detail?.specialization} (
                      {doctorDetails?.doctor_detail?.qualifications})
                    </p>
                  </div>
                </div>{" "}
                <button
                  style={{
                    border: "1px solid #ccc",
                    background: "#fff",
                    padding: "8px 16px",
                    borderRadius: "12px",
                    marginTop: "16px",
                    fontSize: "12px",
                  }}
                  onClick={() => {
                    setDoctorModal(true);
                  }}
                >
                  View Details
                </button>
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "12px",
                  }}
                >
                  <p
                    style={{
                      color: "#666666",
                    }}
                  >
                    {"On the way"}
                  </p>{" "}
                  <p>ETA: {ETA.toFixed(0) < 5 ? 5 : ETA.toFixed(0)} min</p>
                </div>{" "}
                <div
                  style={{
                    width: "100%",
                    background: "#888",
                    borderRadius: "99px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      width: `${progress}%`,
                      height: "100%",
                      background: "#179D82",
                      padding: "2px",
                      borderRadius: "99px",
                    }}
                  ></div>
                </div>
              </div>
              <PrimaryButton
              variant="outlined"
              textVariant="smallBold"
              textClassName="small-bold"
              backgroundColor={STATUS_STYLES.cancelled.tagColor}
              borderColor={STATUS_STYLES.cancelled.textColor}
              text="Request a call"
              onTap={() => {
                  navigate(WebRoutes.REQUEST_CALL, {
                      state: {
                          appointmentId: appointment?.id,
                          teamName: "CT",
                          customerId: appointment?.patient?.id,
                      },
                  });
              }}
            />
            </div>
           
          </div>
          <div
            style={{ width: "100%", marginTop: "16px", paddingInline: "16px" }}
          >
            <h3 style={{ textAlign: "start" }}>Patient Details</h3>
            <div
              style={{
                // display: "flex",
                // justifyContent: "space-between",
                // alignItems: "center",
                background: "#f9f9f9",
                padding: "24px",
                borderRadius: "12px",
              }}
            >
              <div>
                <p>
                  <span style={{ fontWeight: "bold" }}>
                    {" "}
                    {appointment?.patient?.user_full_name || localStorage.getItem("current_patient")}{" "}
                  </span>
                                    <span style={{marginLeft: "12px"}}>
                    {" "}
                    {appointment?.patient?.age || localStorage.getItem("age")}
                    {", "}
                    {appointment?.patient?.gender || localStorage.getItem("gender")}
                  </span>
                                </p>
                                <p style={{margin: "0"}}>Health concerns</p>
                                <p
                                    style={{
                                        padding: "8px 24px",
                                        background: "#D8D8D8",
                                        width: "fit-content",
                                        borderRadius: "12px",
                                        marginTop: "6px",
                                    }}
                                >
                                    {appointment?.appointment_complains?.[0]?.description}
                                </p>

                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginTop: "16px",
                                    }}
                                >
                                    <div>
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M5.33301 1.33301V3.33301"
                                                stroke="#161616"
                                                stroke-miterlimit="10"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M10.667 1.33301V3.33301"
                                                stroke="#161616"
                                                stroke-miterlimit="10"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M2.33301 6.06006H13.6663"
                                                stroke="#161616"
                                                stroke-miterlimit="10"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M14 5.66683V11.3335C14 13.3335 13 14.6668 10.6667 14.6668H5.33333C3 14.6668 2 13.3335 2 11.3335V5.66683C2 3.66683 3 2.3335 5.33333 2.3335H10.6667C13 2.3335 14 3.66683 14 5.66683Z"
                                                stroke="#161616"
                                                stroke-miterlimit="10"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M10.4635 9.13314H10.4694"
                                                stroke="#161616"
                                                stroke-width="1.33333"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M10.4635 11.1331H10.4694"
                                                stroke="#161616"
                                                stroke-width="1.33333"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M7.99666 9.13314H8.00265"
                                                stroke="#161616"
                                                stroke-width="1.33333"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M7.99666 11.1331H8.00265"
                                                stroke="#161616"
                                                stroke-width="1.33333"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M5.52987 9.13314H5.53585"
                                                stroke="#161616"
                                                stroke-width="1.33333"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M5.52987 11.1331H5.53585"
                                                stroke="#161616"
                                                stroke-width="1.33333"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                        {" "}
                                        <span
                                            style={{
                                                marginLeft: "6px",
                                                fontSize: "12px",
                                                borderRight: "1px solid #16161650",
                                                paddingRight: "16px",
                                            }}
                                        >
                      {new Date(
                          appointment?.appointment_start_time
                      ).toLocaleString("en-IN", {
                          dateStyle: "medium",
                      })}
                    </span>
                                    </div>
                                    <div style={{paddingLeft: "16px"}}>
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M14.6663 8.00016C14.6663 11.6802 11.6797 14.6668 7.99967 14.6668C4.31967 14.6668 1.33301 11.6802 1.33301 8.00016C1.33301 4.32016 4.31967 1.3335 7.99967 1.3335C11.6797 1.3335 14.6663 4.32016 14.6663 8.00016Z"
                                                stroke="#161616"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M10.4729 10.1202L8.40626 8.88684C8.04626 8.6735 7.75293 8.16017 7.75293 7.74017V5.00684"
                                                stroke="#161616"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                        <span
                                            style={{
                                                marginLeft: "6px",
                                                fontSize: "12px",
                                            }}
                                        >
                      {new Date(
                          appointment?.appointment_start_time
                      ).toLocaleString("en-IN", {
                          timeStyle: "short",
                      })}
                    </span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <p
                                    style={{
                                        marginTop: "16px",
                                        fontSize: "14px",
                                        marginBottom: "8px",
                                    }}
                                >
                                    Patient Address
                                </p>

                                <p style={{fontSize: "14px"}}>
                                    {appointment?.appointment_address}
                                </p>
                            </div>
                        </div>
                    </div>

                    <UpcomingAppointmentInformation/>

                    {instructionsStatus === "idle" && (
                        <button
                            onClick={() => {
                                const element = document?.getElementById("instruction-bar");
                                if (element) {
                                    element.scrollIntoView({
                                        behavior: "smooth",
                                        block: "end",
                                        inline: "nearest",
                                    });
                                }
                            }}
                            id="inter-btn"
                            style={{
                                border: "1px solid #179D82",
                                borderRadius: "99px",
                                fontSize: "14px",
                                background: "#fff",
                                color: "#179D82",
                                boxShadow: "1px 1px 12px #33333340",
                                position: "fixed",
                                bottom: "6px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "6px",
                                padding: "2px 12px",
                            }}
                        >
                            <svg
                                width="13"
                                height="13"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M13.2802 5.96667L8.93355 10.3133C8.42021 10.8267 7.58021 10.8267 7.06688 10.3133L2.72021 5.96667"
                                    stroke="#179D82"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                            Instructions
                        </button>
                    )}

                    {instructionsStatus === "idle" && (
                        <div
                            id="instruction-bar"
                            style={{
                                width: "100%",
                                marginTop: "16px",
                                paddingBottom: "24px",
                                paddingInline: "16px",
                            }}
                        >
                            <h3 style={{textAlign: "start"}}>
                                Instructions for the doctor (optional)
                            </h3>

              <textarea
                style={{ width: "100%", height: "120px", resize: "none" }}
              ></textarea>
              <BrandButton
                label={"Submit"}
                style={{ width: "100%" }}
                onClick={() => handleInstructions()}
              />
            </div>
          )}
          {instructionsStatus === "success" && (
            <div
              style={{
                width: "calc(100% - 32px)",
                marginTop: "16px",
                padding: "24px",
                background: "#179D820F",
                fontSize: "12px",
                fontWeight: "500",
                marginBottom: "24px",
              }}
            >
              <Completed />
              <p style={{ marginBlock: "12px" }}>Instructions noted!</p>
              <p style={{ margin: "0" }}>
                Please relax, doctor will be at your location shortly
              </p>
            </div>
          )}
        </>
      ) : (
        <>
          {heavyModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 9999, // High z-index to ensure it's on top
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#FFFFFF", // Optional: adds a dim background
              }}
            >
              <ETAFile text={"We're unable to process your request at the moment, but we're working on it! We'll be ready to serve you soon."} func={handleNavigationAdrress} />
            </div>
          )}
          {appId && (
            <>
              <div style={{ width: "100%" }}>
                <div className="arrive-element">
                  Doctor is available to reach{" "}
                  {ETA >= 60
                    ? appointment?.appointment_start_time
                      ? `by ${new Date(
                          appointment?.appointment_start_time
                        ).toLocaleString("en-IN", {
                          timeStyle: "short",
                        })}`
                      : `in ${parseInt(ETA)} Minutes`
                    : `in ${parseInt(ETA)} Minutes`}{" "}
                </div>
                {60 > ETA && ETA >= 30 && (
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#161616",
                      padding: "12px 16px",
                      margin: "0",
                    }}
                  >
                    {" "}
                    Doctor is {appointment?.travel_time} minutes away from you &
                    completing a consultation nearby.
                  </p>
                )}

                {ETA >= 60 && (
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#161616",
                      padding: "12px 16px",
                      margin: "0",
                    }}
                  >
                    {" "}
                    We are facing high demand at the moment.
                  </p>
                )}
              </div>
              {payment !== "success" ? prePaymentLayoutJsx() : doctorDetailsJsx()}
            </>
          )}
          <div className="timer-container">
            <div>
              <h3>To confirm your booking</h3>
              <p>
                {timerStage === 1
                  ? "Proceed to pay within 01:30 Minutes"
                  : // eslint-disable-next-line no-multi-str
                    "This appointment will be auto-canceled shortly"}
              </p>
            </div>
            <div>
              <button
                style={{
                  ...(timerStage === 2 && {
                    border: "1px solid #ce272780",
                    background: "#ce272725",
                    color: "#ce272780",
                  }),
                }}
              >
                {timerStage === 2
                  ? "00:00"
                  : `${Math.floor(payTimer / 60).toLocaleString("en-US", {
                      minimumIntegerDigits: 2,
                    })}:${(payTimer % 60).toLocaleString("en-US", {
                      minimumIntegerDigits: 2,
                    })}`}
              </button>
            </div>
          </div>
          <div className="pay-container">
            <div>
              <h3>Subtotal</h3>
              <p> ₹{subtotal}</p>
            </div>
            <div>
              <BrandButton
                disabled={appId ? false : true}
                style={{
                  paddingInline: "24px",
                  borderRadius: "18px",
                  background: appId ? "#179D82" : "#bbb",
                  color: "#fff",
                }}
                label={"Confirm & Pay"}
                onClick={handlePayment}
              />
            </div>

                        {showSuccess && (
                            <div
                                style={{
                                    position: "absolute",
                                    bottom: "0",
                                    left: "0",
                                    width: "100%",
                                    height: "100%",
                                    background: "#fff",
                                    padding: "10px 0px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    zIndex: "100",
                                }}
                            >
                                <Success/>

                                <p style={{color: "#161616", marginTop: "16px"}}>
                                    Congratulations!!
                                </p>
                                <p
                                    style={{
                                        color: "#161616",
                                        fontWeight: "400",
                                        fontSize: "14px",
                                    }}
                                >
                                    Payment done successfully
                                </p>
                            </div>
                        )}
                    </div>

          {modalIsOpen && (
            <div
              style={{
                position: "fixed",
                inset: "0",
                display: "flex",
                alignItems: "center",
                zIndex: "999",
                justifyContent: "center",
                backdropFilter: "blur(3px) brightness(0.5)",
                height: "100%",
                maxWidth: "500px",
                margin: "0 auto",
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setDoctorModal(false);
              }}
            >
              <div
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                className="modal-con"
                style={{
                  // width: "90%",
                  background: "#fff",
                  // padding: "22px",
                  borderRadius: "12px",
                }}
              >
                <h2>Oops!! Time’s Up</h2>
                <p>
                  Payment not completed in 1:30 minutes. Please try again.
                </p>
                <BrandButton
                  onClick={() => {
                    handleNavigationAdrress();
                  }}
                  label={"Try again"}
                />
                {/* <button
              className="cancel-button"
              onClick={() => {
                setIsOpen(false);
                navigate("/");
              }}
            >
              Cancel
            </button> */}
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
